import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import {
  ProductSeparatedWithTypes,
  ProductToSeparateWithPaymentSettings,
} from "./types";

const getProductsToSeparateAutomatically = (
  productsSeparatedWithTypes: ProductSeparatedWithTypes[],
  productsWithActivePaymentSettings: ProductToSeparateWithPaymentSettings[]
) =>
  isArrayHasItems(productsSeparatedWithTypes)
    ? productsWithActivePaymentSettings.filter(
        ({ sku }) =>
          !productsSeparatedWithTypes.some((product) => product.sku === sku)
      )
    : productsWithActivePaymentSettings;

export default getProductsToSeparateAutomatically;
